// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".edit-actions{top:-15px;margin-bottom:15px}.config-page .edit-actions{margin-top:-35px}.config-page .edit-actions .v-btn{background-color:transparent!important;margin-top:0!important}.user-show .edit-actions{margin-top:5px}.user-show .edit-actions .v-btn{background-color:transparent!important;margin-top:0!important}.user-show .edit-actions .v-btn .v-icon{color:var(--v-darkGray-base)!important}", ""]);
// Exports
module.exports = exports;
